/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
var xtend = require("xtend");

module.exports = Model({
	name: "devicefollowup",
	init: init,
	triggers: triggers,
});

function triggers() {
	return {
		"show": show,
		"submit": submit,
		"cancel": hide
	};
}

function init() {
	this._reading = {};
	this._type = "";
	this.push({
		open: false,
		reading: {},
		type: ""
	});
	this._managerId = null;
}

function show(reading){
	this._reading = reading;
	this._type = reading.type;
	this.push({
		open: true,
		reading: reading,
		type: reading.type
	});
	this._managerId = reading.who;
	this.emit("usermetrics:trigger:track", "view device followup modal", {
		who: reading.who
	});
}

function submit(data){
	var type = this._type;
	var reading = xtend(this._reading, data);

	var promise = this.api.device[type].add(reading);
	if(this._managerId){
		reading.managerId = this._managerId;
		promise = this.api.manage[type].add(this._managerId, reading);
	}

	this.emit("usermetrics:trigger:track", "submit device followup modal", {
		who: this._managerId
	});

	return promise
		.then(hide.bind(this))
		.catch(console.log);
}

function hide(){
	this._reading = {};
	this._type = "";
	this.push({
		open: false,
		reading: {},
		type: ""
	});
	this.emit("usermetrics:trigger:track", "close device followup modal");
}
